import { hexToRgb, getLuminance, safe } from '../utils/contrast.js';
import { estiloDeBoton } from '../utils/boton-estilo.js';
import { t } from '../utils/i18n.js';
import { ctaAnchorAttrs } from '../utils/links.js';
import { conSecundario } from '../utils/boton-secundario.js';

// Bloque Countdown — temporizador de oferta
export const countdownBlock = (rawProps, blockIdx) => {
    const p = safe(rawProps);
    const title = p.title || '¡Oferta limitada! Termina en:';
    const subtitle = p.subtitle || 'No dejes pasar esta oportunidad única.';
    const targetDate = p.target_date || new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toISOString().slice(0, 16);
    const cta = p.cta || t('timer_cta');
    const uid = `cd-${blockIdx}`;

    return `
    <section id="bloque-countdown" class="reveal countdown-section variant-${p.variant || 'v1'}"
             style="--bg:${p.bgColor}; --text:${p.textColor}; --accent:${p.accentColor}; --font:'${p.fontFamily || "Inter"}'; --accent-contrast:${p.accentContrast}; padding:80px 8%; text-align:center; position:relative;">
        
        <h2 data-field="title" contenteditable="true"
            style="font-size:calc(clamp(1.8rem,4cqw,2.8rem) * var(--type-scale, 1)); font-weight:800; margin-bottom:15px;">${title}</h2>
        <p data-field="subtitle" contenteditable="true"
           style="opacity:0.75; font-size:calc(1.1rem * var(--text-scale, 1)); margin-bottom:50px;">${subtitle}</p>
        
        <div class="countdown-display" data-target="${targetDate}">
            <div class="cd-unit"><span class="cd-num" data-unit="d">00</span><span class="cd-label">${t('cd_days')}</span></div>
            <div class="cd-sep">:</div>
            <div class="cd-unit"><span class="cd-num" data-unit="h">00</span><span class="cd-label">${t('cd_hours')}</span></div>
            <div class="cd-sep">:</div>
            <div class="cd-unit"><span class="cd-num" data-unit="m">00</span><span class="cd-label">${t('cd_mins')}</span></div>
            <div class="cd-sep">:</div>
            <div class="cd-unit"><span class="cd-num" data-unit="s">00</span><span class="cd-label">${t('cd_secs')}</span></div>
        </div>

        ${conSecundario(`<a ${ctaAnchorAttrs(p.cta_url)} class="btn-action" data-field="cta" contenteditable="true"
           style="${estiloDeBoton(p, 'cta')}display:inline-block; margin-top:40px;">${cta}</a>`, p, { fila: 'margin-top: 40px;' })}
    </section>`;
};
